// extracted by mini-css-extract-plugin
export default {"container":"audio__container__VQKFB","muted":"audio__muted__xYTlM","soundOn":"audio__soundOn__dPGkK","hide":"audio__hide__xEQCb"};